import React from "react";

const API_BASE = process.env.REACT_APP_API_URL || "https://go.brandhives.com";
const CARD = "#FFFFFF";
const B = "#E1E9EE";
const GRN = "#1D9E75";

const NOTIFICATIONS = [
  { key: "notify_post_live", label: "Post went live", desc: "An email when each post is successfully published to LinkedIn." },
  { key: "notify_post_failed", label: "Post failed", desc: "An alert if a post fails to publish so you can take action." },
  { key: "notify_weekly_digest", label: "Weekly digest", desc: "A summary of your posting activity and engagement every Monday." },
  { key: "notify_tips", label: "Tips & product updates", desc: "Occasional emails with LinkedIn tips and new BrandHives features." },
  { key: "pitch_emails_opt_out", label: "Plan upgrade emails", desc: "Occasional emails about upgrading your plan or returning after cancellation.", inverted: true },
];

export default function NotificationsTab({ user, setUser }) {
  const toggle = async (key) => {
    const newVal = !user?.[key];
    await fetch(`${API_BASE}/app/api/user/settings`, { method: "PATCH", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ [key]: newVal }) });
    setUser(u => u ? { ...u, [key]: newVal } : u);
  };

  return (
    <div>
      <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 12, letterSpacing: "0.2em", color: "#999999", textTransform: "uppercase", marginBottom: 16 }}>Email notifications</div>
      <div style={{ fontSize: 14, color: "#666", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", marginBottom: 20, lineHeight: 1.6 }}>
        Choose which emails BrandHives sends you.
      </div>
      {NOTIFICATIONS.map(({ key, label, desc, inverted }) => {
        const isOn = inverted ? !user?.[key] : !!user?.[key];
        return (
          <div key={key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: CARD, border: `1px solid ${B}`, borderRadius: 10, padding: "14px 18px", marginBottom: 14 }}>
            <div>
              <div style={{ fontSize: 15, marginBottom: 4 }}>{label}</div>
              <div style={{ fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 12, color: "#666666" }}>{desc}</div>
            </div>
            <button
              onClick={() => toggle(key)}
              style={{ background: isOn ? GRN : "#E0E0E0", color: isOn ? "#fff" : "#666", border: "none", borderRadius: 20, padding: "6px 16px", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif", fontSize: 13, cursor: "pointer", minWidth: 56, transition: "all 0.2s" }}
            >{isOn ? "On" : "Off"}</button>
          </div>
        );
      })}
    </div>
  );
}
